import { render, staticRenderFns } from "./view8.vue?vue&type=template&id=c938adaa&scoped=true"
import script from "./view8.vue?vue&type=script&lang=js"
export * from "./view8.vue?vue&type=script&lang=js"
import style0 from "./view8.vue?vue&type=style&index=0&id=c938adaa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c938adaa",
  null
  
)

export default component.exports